import React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import { Row, Col } from 'react-flexbox-grid'
import { useState, useEffect } from 'react';

const Footer = (props) => {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const box = document.getElementById('box');
    const heart = document.getElementById('heart');
    if (box && heart) {
      const handleClick = () => {
        heart.classList.add('animate-up');
      };

      box.addEventListener('click', handleClick);

      return () => {
        box.removeEventListener('click', handleClick);
      };
    }
  }, []);

  const toggleFooter = () => {
    setExpanded(!expanded);
  };

  const renderDomicilio = (datosContacto) => {

    let domicilio = ''

    if (datosContacto.calle)
      domicilio += datosContacto.calle + ' '

    if (datosContacto.numero)
      domicilio += datosContacto.numero + ' '

    if (datosContacto.piso)
      domicilio += `Piso: ${datosContacto.piso} `

    if (datosContacto.departamento)
      domicilio += `Dpto.: ${datosContacto.departamento}`

    return domicilio
  }


  return (
    <div id='footer' style={{ position: 'fixed', bottom: 0, width: '100%', zIndex: 999 }}>
      {expanded ? (
        <>
          {expanded && <span onClick={toggleFooter} className="closeButton">Menos información ↓</span>}
          {props.instalacion.promosBandaDescuentos === true &&
            <div className='descuentos'>
              <div className='title'>DESCUENTOS</div>
              <div className='descriptionText'>CONOZCA NUESTRA ESCALA DE DESCUENTOS!</div>

              {props.instalacion.bandaDescuento !== null ?
                <div className='imageContainer'>
                  <img alt='' src={props.instalacion.bandaDescuento} />
                </div>
                :
                <div className='imageContainer'>
                  <div class="outerD">
                    <div class="middleD">
                      <div class="innerD">
                        <CircularProgress />
                        <div className='nombreItemDescuento'>Descuentos</div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>}

          {props.instalacion.verPiePagina === true &&
            <div className='datosContactoContainer'>

              <Row style={{ margin: '0px', justifyContent: 'center' }}>

                <Col xs={12} md={12} lg={props.existePedido ? 12 : 3} xl={3} style={{ padding: '0px' }}>
                  <div className={`imageContainer ${props.existePedido ? 'imageContainerAux' : ''}`}>
                    {/* <img src={props.instalacion.logoFooter} /> */}
                    <img alt='' src={require('../../images/logoDrawer.png')} />
                    <div className='labelContacto'>

                      {(/*props.instalacion.datosContacto.telefono !== undefined &&*/
                        <div>
                          Teléfono: {props.instalacion.datosContacto.telefono}
                        </div>)}

                      {(props.instalacion.datosContacto && props.instalacion.datosContacto.email !== undefined &&
                        <div style={{ marginTop: '10px' }}>
                          Mail: {props.instalacion.datosContacto.email}
                        </div>)}
                    </div>
                  </div>

                </Col>

                {(props.instalacion.datosContacto.calle !== undefined || props.instalacion.datosContacto.telefono !== undefined || props.instalacion.datosContacto.email !== undefined) &&
                  <Col xs={12} md={12} lg={2} xl={2}>
                    <div className={`datosContacto ${props.existePedido ? 'datosContactoAux' : ''}`}>
                      <div className="title">INFORMACIÓN</div>
                      <div className={`data`} onClick={() => {
                        props.handleOpenArrepentimientoModal();
                      }}>Botón de arrepentimiento</div>
                    </div>
                  </Col>}
                {(props.instalacion.datosContacto.facebook !== undefined
                  || props.instalacion.datosContacto.twitter !== undefined
                  || (props.instalacion.datosContacto.telefono !== undefined && window.chrome !== undefined)
                  || props.instalacion.datosContacto.instagram !== undefined) &&
                  <Col xs={12} md={12} lg={props.existePedido ? 12 : 2} xl={3}>
                    <div className={`redesSociales ${props.existePedido ? 'redesSocialesAux' : ''}`}>
                      <div className="title">REDES SOCIALES</div>

                      <div className={`logosContainer ${props.existePedido ? 'logosContainerAux' : ''}`}>
                        {props.instalacion.datosContacto.facebook !== undefined &&
                          <a className='redSocial' href={props.instalacion.datosContacto.facebook} target="_blank" rel="noopener noreferrer">
                            <FacebookIcon className='logoRed' /> Facebook
                          </a>
                        }

                        {props.instalacion.datosContacto.twitter !== undefined &&
                          <a className='redSocial' href={props.instalacion.datosContacto.twitter} target="_blank" rel="noopener noreferrer">
                            <InstagramIcon className='logoRed' /> Instagram
                          </a>
                        }

                        {props.instalacion.datosContacto.instagram !== undefined &&
                          <a className='redSocial' href={props.instalacion.datosContacto.instagram} target="_blank" rel="noopener noreferrer">
                            <TwitterIcon className='logoRed' /> Twitter
                          </a>
                        }
                      </div>
                    </div>
                  </Col>}

                <Col xs={12} md={12} lg={2} xl={2}>
                </Col>

                <Col xs={12} md={12} lg={props.existePedido ? 12 : 4} xl={3} style={{ padding: '0px' }}>
                </Col>
              </Row>
            </div>}
        </>
      ) : (
        <Row style={{ margin: '0px', justifyContent: 'center' }}>

          <Col xs={12} md={12} lg={props.existePedido ? 12 : 8} xl={8} style={{ padding: '0px' }}>
          </Col>

          <Col xs={12} md={12} lg={12} style={{ padding: '0px' }}>
            <div className={`desarrolloBy`}>
              <a className='desarrolloByAnchor' style={{ color: 'white' }} href="https://www.diveria.com/" target="_blank" rel="noopener noreferrer">
                Diseño y desarrollo Diveria SRL - Ideas that really work
              </a>
            </div>
            <div onClick={toggleFooter} className={`expandButton ${expanded ? 'expanded' : ''}`}>
              <span
                className={`openButton`}
              >
                Mas información ↑
              </span>
            </div>
          </Col>

        </Row>
      )}
    </div>
  )
}

Footer.propTypes = {
  instalacion: PropTypes.object.isRequired,
  marginBottomFooter: PropTypes.bool.isRequired,
  existePedido: PropTypes.bool.isRequired,
  handleOnClickBasesCondiciones: PropTypes.func.isRequired,
}

export default Footer